import useTypedContext from "hooks/useTypedContext";
import { SpacesContext } from "views/Account/SpacesProvider";
import { AccountContext } from "views/AccountWrapper";

import useIsNonRootApiKeyManagementEnabled from "./useIsNonRootApiKeyManagementEnabled";

/** Not the final check — the backend re-authorizes every space the new key touches on submit. */
const useCanCreateApiKeys = (): boolean => {
  const { viewer } = useTypedContext(AccountContext);
  const { hasManageableSpaces } = useTypedContext(SpacesContext);
  const isNonRootManagementEnabled = useIsNonRootApiKeyManagementEnabled();

  return viewer.admin || (isNonRootManagementEnabled && hasManageableSpaces);
};

export default useCanCreateApiKeys;
